<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaDoencas"
        title-table="Doenças CID"
        module="doencasCidSettingsModule"
        sort-name="descricao"
        :show-btn-add="verificarPermissao('ROLE_ATEND_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ATEND_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormDoencaCid v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormDoencaCid from './forms/FormDoencaCid.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormDoencaCid
  },
  computed: {
    ...mapState('doencasCidSettingsModule', {
      listaDoencas: (state) => state.listaDoencas
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Descrição',
          field: 'descricao'
        },
        {
          label: 'Especialidade',
          field: 'especialidade.descricao'
        },
        {
          label: 'Ativo',
          field: 'ativo'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('doencasCidSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
